import Vue from 'vue';
import Component from 'vue-class-component';
import {Prop, Watch} from 'vue-property-decorator';
import Popper from 'popper.js';

export enum PopoverTrigger {
  Click = 'click',
  Hover = 'hover',
  Static = 'static'
}

export enum PopoverPlacement {
  Top = 'top',
  Right = 'right',
  Bottom = 'bottom',
  BottomStart = 'bottom-start',
  Left = 'left'
}

@Component({
  template: require('./popover.html'),
  name: 'wc-popover'
})
export class Popover extends Vue {
  @Prop()
  placement: PopoverPlacement;

  @Prop()
  title: string;

  @Prop()
  content: string;

  @Prop({
    default: PopoverTrigger.Click
  })
  trigger: PopoverTrigger;

  @Prop()
  className: string;

  @Prop({
    default: true
  })
  arrowVisible: boolean;

  @Prop({
    default: false
  })
  show: boolean;

  @Prop({
    default: true
  })
  conditionalShow: boolean;

  @Prop()
  onShow: () => void;

  @Prop()
  onHide: () => void;

  popper: Popper;
  delayOnMouseOut: number = 10;
  showPopover: boolean = false;
  timer: number;
  clickOutsideHandler: () => void;
  
  @Watch('placement')
  update() {
    this.createPopper();
  }

  @Watch('trigger')
  updateTrigger() {
    this.trigger = this.trigger;
  }

  @Watch('show')
  showUpdate() {
    this.showPopover = this.show;
  }

  @Watch('showPopover')
  updatePopover() {
    if (this.popper) {
      this.popper.update();
    }

    if (this.showPopover && this.onShow) {
      this.onShow.call(this);
    } else if (this.onHide) {
      this.onHide.call(this);
    }
  }

  mounted() {
    if (this.trigger === PopoverTrigger.Static) this.createPopper();
  }

  createPopper() {
    let placement = this.placement || PopoverPlacement.Top;

    
    if (this.popper) this.popper.destroy(); 
    this.popper = new Popper((this.$refs.referenceElement as Element).firstChild as Element, this.$refs.popperElement as Element, {
      placement: placement
    });

    if (this.trigger === PopoverTrigger.Static) {
      this.showPopover = true;
    }

    if (!this.clickOutsideHandler && this.trigger === PopoverTrigger.Click) {
      window.document.addEventListener('mousedown', this.outsideClick.bind(this), false);
    }
    
  }

  outsideClick(e: Event) {
     if (!this.$el || !this.$refs.referenceElement ||
      this.$el.contains(e.target as Node) ||
      (this.$refs.referenceElement as Element).contains(e.target  as Node) ||
      !this.$refs.popperElement || (this.$refs.popperElement as Element).contains(e.target  as Node)
    ) {
      return;
    }

    this.showPopover = false;
  }

  onMouseOver() {
    if (!this.popper) this.createPopper()

    if (this.trigger !== PopoverTrigger.Hover) return;
    this.showPopover = true;
    clearTimeout(this.timer);
  }

  onMouseOut() {
    if (this.trigger !== PopoverTrigger.Hover) return;

    this.timer = window.setTimeout(() => {
      this.showPopover = false;
    }, this.delayOnMouseOut);
  }

  onClick() {
    if (this.trigger !== PopoverTrigger.Click) return;

    this.showPopover = !this.showPopover;
  }

  destroyed() {
    window.document.removeEventListener('mousedown', this.outsideClick.bind(this), false);
  }
}




// WEBPACK FOOTER //
// node_modules/wc-lib/src/wc-ui/components/popover/popover.ts